<head>
	<title>臺中市交通行動服務(MAAS)_交通總覽</title>
</head>
<header class="d-flex justify-content-between">
	<div><a href="#"><img src="/static/images/svg/ic_back.svg" alt="回上一頁"></a></div>
	<div><a href="#"><img src="/static/images/svg/home.svg" alt="回首頁"></a></div>
</header>

<div class="trfmenu">
	<ul>
		<li>
			<a [class.active]="state == 'ALL'" (click)="showMarker('ALL')" role="button">
				<div class="icon">
					<img src="/static/images/svg/map_w_all.svg" alt="全部">
				</div>
				<p>全部</p>
			</a>
		</li>

		<li>
			<a [class.active]="state == 'MRT'" (click)="showMarker('MRT')" role="button">
				<div class="icon">
					<img src="/static/images/svg/map_w_mrt.svg" alt="捷運">
				</div>
				<p>捷運</p>
			</a>
		</li>

		<li>
			<a [class.active]="state == 'THSR'" (click)="showMarker('THSR')" role="button">
				<div class="icon">
					<img src="/static/images/svg/map_w_thsr.svg" alt="高鐵">
				</div>
				<p>高鐵</p>
			</a>
		</li>

		<li>
			<a [class.active]="state == 'TRA'" (click)="showMarker('TRA')" role="button">
				<div class="icon">
					<img src="/static/images/svg/map_w_tra.svg" alt="臺鐵">
				</div>
				<p>臺鐵</p>
			</a>
		</li>

		<li>
			<a [class.active]="state == 'BUS'" (click)="showMarker('BUS')" role="button">
				<div class="icon">
					<img src="/static/images/svg/map_w_bus.svg" alt="市區公車">
				</div>
				<p>市區公車</p>
			</a>
		</li>

		<li>
			<a [class.active]="state == 'NHPT'" (click)="showMarker('NHPT')" role="button">
				<div class="icon">
					<img src="/static/images/svg/map_w_nhpt.svg" alt="國道客運">
				</div>
				<p>國道客運</p>
			</a>
		</li>

		<li>
			<a [class.active]="state == 'BIKE'" (click)="showMarker('BIKE')" role="button">
				<div class="icon">
					<img src="/static/images/svg/map_w_ibike.svg" alt="iBike2.0">
				</div>
				<p>YouBike2.0</p>
			</a>
		</li>




		<li>
			<!-- <a href="https://maas1.metropia.biz/trip-planning/directions" target="_blank"> -->
			<a href="/map/train" target="_blank">
				<div class="icon">
					<img src="/static/images/svg/map_w_plan.svg" alt="旅運規劃">
				</div>
				<p>旅運規劃</p>
			</a>
		</li>


	</ul>
</div>

<div class="mapimg">
	<traffic-google-map (callBack)="showDetail($event.type, $event.name, $event.stationId)"></traffic-google-map>
	<div class="map_in">
		<a (click)="callMap_getLocal()" role="button">以地圖中央尋找附近站點(點此返回我的位置)</a>
	</div>
</div>



<!--捷運-->
@if ( type == "MRT") {
	<mrt-traffic [name]="this.name" (callBack)="close()"/>
}

<!--高鐵-->
@if ( type == "THSR") {
	<thsr-traffic [name]="this.name" (callBack)="close()"/>
}

<!--高鐵-->
@if ( type == "TRA") {
	<tra-traffic [name]="this.name" [stationId]="this.stationId" (callBack)="close()"/>
}

<!--市區公車-->
@if ( type == "BUS") {
	<bus-traffic [name]="this.name" [stationId]="this.stationId" (callBack)="close()"/>
}

<!--自行車-->
@if ( type == "NHPT") {
	<nhpt-traffic [name]="this.name" [stationId]="this.stationId" (callBack)="close()"/>
}

<!--自行車-->
@if ( type == "BIKE") {
	<bike-traffic [name]="this.name" [stationId]="this.stationId" (callBack)="close()"/>
}
